import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";

// === Styled Components ===
const Section = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "120px 10%",
  backgroundColor: "#fff",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column", // stack for mobile
    textAlign: "center",
    padding: "80px 5%",
  },
}));

const TiltedImage = styled("img")(({ theme, rotate }) => ({
  width: "45%", // side-by-side layout
  height: "auto",
  objectFit: "cover",
  transform: `rotate(${rotate || "-8"}deg)`,
  borderRadius: "14px",
  boxShadow: "0 20px 40px rgba(0,0,0,0.25), 0 6px 12px rgba(0,0,0,0.15)",
  transition: "transform 0.5s ease, box-shadow 0.5s ease",
  "&:hover": {
    transform: `rotate(${rotate || "-8"}deg) scale(1.05)`,
    boxShadow: "0 25px 45px rgba(0,0,0,0.35), 0 10px 20px rgba(0,0,0,0.2)",
  },
  [theme.breakpoints.down("md")]: {
    width: "90%", // full width on small screens
    marginTop: "30px",
  },
}));

const TextBox = styled(Box)(({ theme }) => ({
  width: "50%",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

const Subheading = styled(Typography)({
  fontSize: "1.1rem",
  color: "#444",
  marginTop: "16px",
  lineHeight: 1.7,
});

// === Main Component ===
export default function AboutSection() {
  return (
    <Box sx={{ overflowX: "hidden" }}>
      {/* Section 1 */}
      <Section>
        <TextBox>
          <Subheading sx={{ mt: 3 }}>
            Intrinsic Clinical Systems is the result of decades of extensive
            pharmaceutical, clinical trial, project management, and operations
            experience. We’ve held the same jobs you’ve held, and we’ve done the
            work you’re doing now. We’ve felt those same frustrations with
            overcomplicated software products that don’t quite do what you need
            them to do. Now we’ve made it our mission to design simple,
            easy-to-use software for the pharmaceutical industry – software that
            is intuitive and simply managed internally.
          </Subheading>
        </TextBox>
         
 <TiltedImage
          src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=800&q=80"
          rotate="8"
          alt="collaboration"
        />
      
      </Section>

      {/* Section 2 */}
      <Section sx={{ backgroundColor: "#fafafa" }}>
       
          <TiltedImage
          src={`${process.env.PUBLIC_URL}/aboutPageImage2.png`}
          rotate="-6"
          alt="team discussion"
        />

        <TextBox>
          <Subheading sx={{ mt: 2 }}>
            If you’re looking for a solution that is more scalable than Excel
            but not as complicated as legacy applications, Intrinsic is for you.
            Having worked with traditional clinical trial management systems,
            feasibility tools, resource planning applications, and time tracking
            tools, we’ve felt the pain that comes with the needless features and
            huge price tags of those other systems. We’ve heard the industry’s
            requests for cloud-based tools that are affordable, easy to use, and
            don’t require an IT department to manage. Our solutions can be
            implemented in a matter of weeks, not years like other systems on
            the market. We provide the stability you need to grow and succeed.
          </Subheading>
        </TextBox>
      </Section>

      {/* Section 3 */}
      <Section>
        <TextBox>
          <Subheading>
            See for yourself – schedule a time to discuss your needs and to walk
            through a demo with us.
          </Subheading>
          <Box sx={{ mt: 3 }}>
            <Button
              variant="contained"
              component={Link}
              to="/request-demo"
              sx={{
                backgroundColor: "#03a9f4",
                padding: "8px 32px",
                color: "white",
                fontWeight: 600,
                fontSize: { xs: "1rem", md: "1.1rem" },
                borderRadius: "20px",
                textTransform: "none",
                "&:hover": { backgroundColor: "#0288d1" },
              }}
            >
              Request Demo
            </Button>
          </Box>
        </TextBox>

        <TiltedImage
          src={`${process.env.PUBLIC_URL}/about_third.png`}
          rotate="-8"
          alt="career opportunities"
        />
      </Section>
    </Box>
  );
}
